import * as React from 'react';

import {Icon} from '../Icon/Icon';
import {ClassNameBuilder} from '../../utils/ClassNameBuilder';

import * as Styles from './ErrorMessage.module.scss';

interface Props {
    icon: string;
    title: string;
    subtitle?: string;
    className?: string;
    contactInfo?: boolean;
}

export const ErrorMessage: React.FC<Props> = (props) => {
    const {icon, title, subtitle, className, contactInfo = true} = props;

    const containerClass = new ClassNameBuilder(Styles, 'container')
        .add(className)
        .toString();

    return (
        <div className={containerClass}>
            <div className={Styles.centeredBox}>
                <Icon className={Styles.icon} src={icon} />
                <span className={Styles.title}>{title}</span>
                {subtitle && <span className={Styles.subtitle}>{subtitle}</span>}
            </div>
            {contactInfo && <div className={Styles.contact}>Need Assistance? <a href="mailto:support@openfin.co" className={Styles.link}>CONTACT US</a></div>}
        </div>
    );
};
